/* eslint-disable import/extensions, import/no-unresolved */
import React from 'react';
import { FONT_SIZE } from '@latitude/core/utils/constants';
import { StaticImage } from 'gatsby-plugin-image';

import {
  StyledHeroBranded,
  ImageBox,
  LeaderDetailsWrapper,
  DetailsContainer,
  StyledText,
  LeadershipPageLayout
} from '../../../components/Leadership';

export default props => {
  const title = 'Felicity Joslin';
  const content =
    'Chief People Officer and Executive General Manager, People and Culture';

  return (
    <LeadershipPageLayout title={title} {...props}>
      <StyledHeroBranded
        title={title}
        text={content}
        breadcrumbs={[
          {
            name: 'About us',
            href: '/about-us/'
          },
          {
            name: 'Our company',
            href: '/about-us/our-company/'
          },
          {
            name: 'Felicity Joslin'
          }
        ]}
        imageContent={
          <ImageBox>
            <StaticImage
              alt={title}
              src="../images/felicity-joslin-1.webp"
              width={450}
              quality={100}
              placeholder="dominantColor"
            />
          </ImageBox>
        }
      />
      <LeaderDetailsWrapper>
        <DetailsContainer display="flex">
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Felicity joined Latitude in August 2023 as Chief People Officer and
            Executive General Manager, People & Culture.
            <br />
            <br />
            She has over 20 years’ experience in academia and professional
            services and has worked in a variety of roles in public and private
            organisations across Australia, the US and the UK. Before Latitude,
            Felicity led People & Culture teams in several digital businesses,
            including Wesfarmers’ OneDigital division, The Iconic and Afterpay,
            who were all at different stages of the “start-up” journey. She
            spent 11 years at NAB both in Business Partnering and Centre of
            Excellence roles, and prior to that worked in similar roles at
            Invesco.
          </StyledText>
          <StyledText fontSize={FONT_SIZE.LARGE}>
            Felicity holds a Bachelor of Arts and Doctor of Industrial &
            Organisational Psychology degrees, both from The University of
            Melbourne.
          </StyledText>
        </DetailsContainer>
      </LeaderDetailsWrapper>
    </LeadershipPageLayout>
  );
};
